module.exports = __webpack_public_path__ + "static/media/nodejs-og.cb6939d9.svg";